<template>
  <div class="card modal-card-diaporama modal-card-border">
    <div class="card-content"  v-if="faces && faces.length > 0">
      <header>
        <div class="columns">
          <div class="column is-1">
            <a @click.prevent="prevSlide">
              <b-icon icon="chevron-left" class="arrow" size="is-large" type="is-gris"></b-icon>
            </a>
          </div>
          <div class="column is-10">
            <carousel ref="carousel"
                      :per-page="1" :autoplay="true"
                      :autoplay-timeout="5000"
                      :pagination-enabled=false
                      :click-target-size=20
                      :loop="true">
              <slide :key="index" v-for="(face, index) in faces">
                <div class="imageContainer">
                  <img v-if="face.urlPhoto" class="image" :src="face.urlPhoto"/>
                  <img v-else class="image" src="@/assets/default-placeholder.png"/>
                </div>
                <div class="columns">
                  <div class="column is-7">
                    <p>Code Face : <strong>{{face.facCode}}</strong></p>
                    <p>Réseau : <strong>{{face.libelleReseau}}</strong></p>
                    <p>Adresse : <strong>{{face.adresseCommercialeLibelle1}}
                      <br/>{{face.codePostal}} {{face.ville}}</strong></p>
                  </div>
                  <div class="column">
                    <p>Format : <strong>{{face.format}}</strong></p>
                  </div>
                </div>
              </slide>
            </carousel>
          </div>
          <div class="column is-1">
            <a @click.prevent="nextSlide">
              <b-icon icon="chevron-right" class="arrow" size="is-large" type="is-gris"></b-icon>
            </a>
          </div>
        </div>

      </header>
      <br>
    </div>
    <div class="card-content" v-else>
        <h1 class="card-header-title">Diaporama non disponible</h1>
        <p class="card-content">Aucune face n'est presente</p>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'Diaporama',
  props: ['faces'],
  components: {
    Carousel,
    Slide,
  },
  methods: {
    nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
  },
};
</script>

<style scoped>
  .image {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-height: 550px;
    max-width: 700px;
  }

  .arrow {
    height: 65vh;
  }

  .imageContainer {
    height: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/general/diaporama.vue